var GraficoIdEnum = {
  RESUMO_SITUACAO_CONCILIACAO: 213,
  RESUMO_FINANCEIRO_PLANO_CONCILIACAO: 211,
  DISTRIBUICAO_CONCILIACAO_LOTE: 212,
  SALDO_BANCARIO: 214,
  GADGET_TAREFAS: 209,
  SALDO_CARTEIRA_DIGITAL: 4005
}

export default GraficoIdEnum



// WEBPACK FOOTER //
// ./client/enum/graficoId.js